import React, { Component } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './coins-and-badges.css';

import {
  ContentHeader
} from '../../components';

export default class CoinsAndBadges extends Component {
  constructor(props) {
    super(props);

    this.state = {
      "extract": [],
      "active_tab": "coins",
      "coins": null,
      "badges": null
    }
  }

  componentWillMount() {
    AOS.init();

    this.getCoins();
    this.getBadges();
  }

  formatCoins(numb) {
    return numb.toLocaleString('pt-br');
  }

  getCoins() {
    var count = 0;
    var data = JSON.parse(window.localStorage.getItem("rdp-super-app-coins"));

    for (var i = 0; i < data.length; i++) {
      count += data[i].coins;
    };

    this.setState({
      "extract": data,
      "coins": this.formatCoins(count)
    });
  }

  getBadges() {
    if (window.localStorage.getItem("rdp-super-app-badges") !== null) {
      this.setState({
        "badges": JSON.parse(window.localStorage.getItem("rdp-super-app-badges"))
      });
    }
  }

  getMessage(item) {
    var message = "";
    if (item.type === "sign_up") {
      message = "Você se cadastrou no T&D Super App!"
    } else if (item.type === "facebook_share" && item.target === "event") {
      message = "Você compartilhou um evento via Facebook!"
    } else if (item.type === "x_share" && item.target === "event") {
      message = "Você compartilhou um evento via X!"
    } else if (item.type === "linkedin_share" && item.target === "event") {
      message = "Você compartilhou um evento via LinkedIn!"
    } else if (item.type === "checkin" && item.target === "talk") {
      message = "Você fez o checkin em uma palestra presencial!"
    } else if (item.type === "additional_content" && item.target === "talk") {
      message = "Você consumiu um material complementar de uma palestra presencial!"
    } else if (item.type === "challenge" && item.target === "talk") {
      message = "Você completou um desafio de palavras-chave!"
    }

    return message;
  }

  render() {
    return (
      <div className="rdp-react-template-component-coins-and-badges">
        <ContentHeader
          title="Minhas Conquistas"
          onBack={() => this.props.onClose && this.props.onClose()}
        />
        <ul className="rdp-react-template-component-coins-and-badges-menu">
          <li className={`rdp-react-template-component-coins-and-badges-menu-item ${this.state.active_tab === "coins" ? "active" : ""}`} onClick={() => this.setState({"active_tab": "coins"})}>
            <span className="rdp-react-template-component-coins-and-badges-menu-item-label">BV Coins</span>
          </li>
          <li className={`rdp-react-template-component-coins-and-badges-menu-item ${this.state.active_tab === "badges" ? "active" : ""}`} onClick={() => this.setState({"active_tab": "badges"})}>
            <span className="rdp-react-template-component-coins-and-badges-menu-item-label">Carimbos</span>
          </li>
        </ul>
        <div className="rdp-react-template-component-coins-and-badges-content">

          {this.state.active_tab === "coins" &&
            <div className="rdp-react-template-component-coins-and-badges-coins">
              <div className="rdp-react-template-component-coins-and-badges-box-coins" data-aos="fade-up" data-aos-duration="500">
                <div className="rdp-react-template-component-coins-and-badges-box-coins-title" data-aos="fade-up" data-aos-duration="500" data-aos-delay="100">Saldo de BV Coins</div>
                <div className="rdp-react-template-component-coins-and-badges-box-coins-container">
                  <span className="rdp-react-template-component-coins-and-badges-box-coins-icon" data-aos="fade-up" data-aos-duration="500" data-aos-delay="200"></span>
                  <span className="rdp-react-template-component-coins-and-badges-box-coins-value" data-aos="fade-up" data-aos-duration="500" data-aos-delay="300">{this.state.coins}</span>
                </div>
              </div>
              <div className="rdp-react-template-component-coins-and-badges-box-coins-footer" data-aos="fade-up" data-aos-duration="500"></div>

              <div className="rdp-react-template-component-coins-and-badges-box-coins" data-aos="fade-up" data-aos-duration="500">
                <div className="rdp-react-template-component-coins-and-badges-box-coins-title" data-aos="fade-up" data-aos-duration="500" data-aos-delay="100">Extrato de BV Coins</div>
                <div className="rdp-react-template-component-coins-and-badges-box-coins-extract">
                  {this.state.extract.map(item => {
                    return <li className="rdp-react-template-component-coins-and-badges-box-coins-extract-item">
                      <div className="rdp-react-template-component-coins-and-badges-box-coins-extract-data">
                        <span className="rdp-react-template-component-coins-and-badges-box-coins-extract-item-title" data-aos="fade-up" data-aos-duration="500" data-aos-delay="100">BV Coins Acumulados</span>
                        <span className="rdp-react-template-component-coins-and-badges-box-coins-extract-item-message" data-aos="fade-up" data-aos-duration="500" data-aos-delay="200">{this.getMessage(item)}</span>
                      </div>
                      <span className="rdp-react-template-component-coins-and-badges-box-coins-extract-item-value" data-aos="fade-up" data-aos-duration="500" data-aos-delay="300">{this.formatCoins(item.coins)}</span>
                    </li>
                  })}
                </div>
              </div>
              <div className="rdp-react-template-component-coins-and-badges-box-coins-footer" data-aos="fade-up" data-aos-duration="500"></div>
            </div>
          }

          {this.state.active_tab === "badges" &&
            <ul className="rdp-react-template-component-coins-and-badges-badges">
              {this.state.badges && this.state.badges.map(function (item, index) {
                return <li className={`rdp-react-template-component-coins-and-badges-badge ${item.exist ? "active" : ""}`} data-aos="fade-up" data-aos-duration="500"  data-aos-delay={index * 100}>
                  {item.exist &&
                    <span className="rdp-react-template-component-coins-and-badges-badge-label">{item.label}</span>
                  }
                </li>
              })}
            </ul>
          }
        </div>
      </div>
    );
  }
}
